import { FC } from 'react';

import Select, { SelectProps } from 'components/Select';

type Props = Omit<SelectProps, 'options'>;

const options = [
  { value: 'BAGGAGE', label: 'Bagažas' },
  { value: 'TRANSFER', label: 'Pervežimas' },
];

const AgreementBlockSelect: FC<Props> = props => (
  <Select options={options} {...props} />
);

export default AgreementBlockSelect;
